// Workspace App — Pending-approval holding screen.
// Shown after a successful Google Sign-In when the user's status is
// `pending_approval`. Blocks dashboard access until an admin approves.

import React from "react";
import { useNavigate } from "react-router-dom";
import { Clock, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export default function WorkspacePendingApprovalPage() {
  const navigate = useNavigate();

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    navigate("/workspace-app");
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: "var(--hoip-bg)" }}
      data-testid="workspace-pending-approval"
    >
      <div
        className="max-w-md border rounded-sm p-8 text-center"
        style={{
          background: "var(--hoip-card)",
          borderColor: "var(--hoip-border)",
        }}
      >
        <Clock className="w-10 h-10 mx-auto mb-4 text-amber-400" />
        <h1
          className="text-xl font-bold mb-3"
          style={{ fontFamily: "Chivo, sans-serif", color: "var(--hoip-text-primary)" }}
          data-testid="workspace-pending-title"
        >
          Your request is awaiting approval
        </h1>
        <p className="text-sm mb-6" style={{ color: "var(--hoip-text-secondary)" }}>
          Thanks for signing in. An administrator has been notified and will
          review your access request. You&apos;ll receive an email once your
          account is approved.
        </p>
        <Button
          variant="outline"
          size="sm"
          className="text-[11px]"
          onClick={logout}
          data-testid="workspace-pending-logout"
        >
          <LogOut className="w-3 h-3 mr-1" />
          Sign out
        </Button>
      </div>
    </div>
  );
}
